import { CustomSingleSelectFieldProps, SelectField } from 'components/form'
import { TipoGravidez, TipoGravidezEnum } from 'graphql/types.generated'
import { useMemo } from 'react'
import { isUndefinedOrNull } from 'util/checks'

export interface TipoGravidezSelectFieldModel {
  value: TipoGravidezEnum
  label: string
}

export type TipoGravidezSelectFieldProps = DistributiveOmit<
  CustomSingleSelectFieldProps<TipoGravidezSelectFieldModel>,
  'initialValue'
> & {
  isPreNatal?: boolean
  initialValue?: TipoGravidez
}

export default function TipoGravidezSelectField(props: TipoGravidezSelectFieldProps) {
  const { isPreNatal = false, initialValue, ...rest } = props

  const valorInicial: TipoGravidezSelectFieldModel | undefined = useMemo(
    () =>
      initialValue
        ? {
            value: initialValue.tipoGravidez,
            label: initialValue.descricao,
          }
        : undefined,
    [initialValue]
  )

  const items = isPreNatal ? allItems : itemsPuericultura
  const isRequired = isPreNatal ? !isUndefinedOrNull(valorInicial) : false

  return (
    <SelectField<TipoGravidezSelectFieldModel>
      label='Tipo de gravidez'
      items={items}
      itemToString={(i) => i?.label}
      initialValue={valorInicial}
      required={isRequired}
      {...rest}
    />
  )
}

const itemsCommon: TipoGravidezSelectFieldModel[] = [
  {
    value: TipoGravidezEnum.UNICA,
    label: 'Única',
  },
  {
    value: TipoGravidezEnum.DUPLA_GEMELAR,
    label: 'Dupla / Gemelar',
  },
  {
    value: TipoGravidezEnum.TRIPLA_OU_MAIS,
    label: 'Tripla ou mais',
  },
]

export const itemsPuericultura: TipoGravidezSelectFieldModel[] = [...itemsCommon]

const allItems: TipoGravidezSelectFieldModel[] = [
  ...itemsCommon,
  { value: TipoGravidezEnum.IGNORADA, label: 'Ignorada' },
]
